import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

// Components
import Switch from '@material-ui/core/Switch';

// Styles
import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  title: React.ReactNode | string;
  description: React.ReactNode | string;
  value: boolean;
  onChange: (e: any) => void;
}

function ThemingSettings({ title, value, onChange, description }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.label}>
        <div className={classes.title}>{title}</div>
        <div className={classes.subtitle}>{description}</div>
      </div>
      <Switch
        checked={value}
        color="secondary"
        inputProps={{ 'aria-label': 'theming switch' }}
        name={'theming-settings'}
        onChange={onChange}
      />
    </div>
  );
}

const useStyles = makeStyles((theme: any) => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    label: {
      flex: '0 1 auto',
      width: 360,
      marginRight: 'auto',
      display: 'flex',
      flexDirection: 'column',
    },
    title: {
      ...theme.typography.body2,
      fontWeight: theme.typography.fontWeight.bold,
      marginBottom: theme.spacing(1),
    },
    subtitle: {
      ...theme.typography.caption,
    },

    description: {
      ...theme.typography.caption,
      flex: '1 1 auto',
      marginRight: theme.spacing(2),
    },
  };
});
export default ThemingSettings;
